/**

@module

## Anatomy

```jsx
import {
  TooltipPopup,
  TooltipPositioner,
  TooltipRoot,
  TooltipTrigger,
} from 'prosekit/react/tooltip'

<TooltipRoot>
  <TooltipTrigger>...</TooltipTrigger>
  <TooltipPositioner>
    <TooltipPopup>...</TooltipPopup>
  </TooltipPositioner>
</TooltipRoot>
```
*/

'use client'

export * from './index.gen.ts'
